window.$ &&
  $(document).ready(function () {
    $(document).on('click', '.coupon-copy-btn', function (e) {
      copyMethod($(this).attr('data'));
      $(this).text('Copied');
    });
    $(document)
      .on('click', '.apply-discount-btn', function (e) {
        e.preventDefault();
        applyDiscount(
          $(this)
            .parent('.cart-sidebar-discount')
            .find('#discount-code-input')
            .val()
        );
      })
      .on(
        'click',
        '.applied-discount-code .applied-discount-code-wrapper,.clear-discount-btn',
        function (e) {
          e.preventDefault();
          let current_code = $(this).attr('data');
          clearDiscount(current_code);
        }
      );
    //getShippingRate();

    if (!getCustomCookie('has_clicked_needs_btn')) {
      $('.needsclick').css('display', 'block');
    }
    $(document)
      .on('click', '.needsclick-btn', function (e) {
        e.preventDefault();
        $('.needsclick').css('display', 'none');
        setCookie('has_clicked_needs_btn', '1', 365);
      })
      .on('click', '.needsclick-text', function (e) {
        e.preventDefault();
        document.querySelector('pop-up').open();
        $('.needsclick').css('display', 'none');
      })
      .on('click', '.js-close-modal,.modal.popup-section', function (e) {
        if (e.target !== this) return;
        e.preventDefault();
        e.stopPropagation();
        $('.needsclick').css('display', 'block');
        return false;
      });
  });

function getCustomCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

window.shipping_fee = 0;
window.money_format = '${{amount}}';
window.settings_new = { moneyFormat: '\$\{\{ amount \}\}' };
Shopify.formatMoney = function (cents, format) {
  var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function showTotalData(data, flag, currentCode) {
  if (data.items.length <= 0) {
    return;
  }
  if (data.total_discount > 0) {
    var code_list = [];
    var code_list_err = [];
    if (data.cart_level_discount_applications.length > 0) {
      data.cart_level_discount_applications.forEach((i) => {
        if (typeof i.discount_application != 'undefined') {
          code_list.push(i.discount_application.title.toUpperCase());
        } else if (typeof i.title != 'undefined') {
          code_list.push(i.title.toUpperCase());
        }
      });
      data.discount_codes.forEach((i) => {
        if (i.applicable == false) {
          if (typeof i.code != 'undefined' && i.code==currentCode) {
            code_list_err.push(i.code.toUpperCase());
          } else if (i.title && typeof i.title != 'undefined') {
            code_list_err.push(i.title.toUpperCase());
          }
        }
      });
    } else if (data.discount_codes.length > 0) {
      data.discount_codes.forEach((i) => {
        if (i.applicable == true) {
          if (typeof i.code != 'undefined') {
            code_list.push(i.code.toUpperCase());
          } else if (typeof i.title != 'undefined') {
            code_list.push(i.title.toUpperCase());
          }
        } else if (i.applicable == false && i.code != 'none' && i.code == currentCode) {
          if (typeof i.code != 'undefined') {
            code_list_err.push(i.code.toUpperCase());
          } else if (typeof i.title != 'undefined') {
            code_list_err.push(i.title.toUpperCase());
          }
        }
      });
    }
    var code_html = '';
    code_list.forEach((item_c) => {
      code_html +=
        '<span class="applied-discount-code-wrapper" style="display: inline-flex;" data="' +
        item_c +
        '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg><span class="applied-discount-code-value" data="' +
        item_c +
        '">' +
        item_c +
        '</span><a href="javascript:void(0);" class="clear-discount-btn" data="' +
        item_c +
        '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" ><path stroke-linecap="round" d="M2.8 2.8 7 7m4.2 4.2L7 7m0 0 4.2-4.2M7 7l-4.2 4.2"></path></svg></a></span>';
    });
    $('.applied-discount-code').html(code_html);
    $('.applied-discount-code2').removeClass('hide');
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, settings_new.moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, settings_new.moneyFormat)
    );
    let cart_total = data.total_price + window.shipping_fee;
    $('.cart_total_money').html(
      Shopify.formatMoney(data.total_price, settings_new.moneyFormat)
    );
    var code_html_err = '';
    var code_html_err2 = '';
    code_list_err.forEach((item_c) => {
      if (
        currentCode &&
        item_c.indexOf(String(currentCode).toUpperCase()) !== -1
      ) {
        code_html_err +=
          "<div class='clear_discount_error'>" +
          '<p><strong>' +
          item_c +
          '</strong>' +
          "<span class='clear_discount_error_text'>couldn't be used with your existing discounts.</span></p>" +
          '<a href="javascript:void(0);" class="clear-discount-btn" data="' +
          item_c +
          '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true"><path stroke-linecap="round" d="M2.8 2.8 7 7m4.2 4.2L7 7m0 0 4.2-4.2M7 7l-4.2 4.2"></path></svg></a></div>';
      } else {
        $('.discount-code-error').html('Please Enter a Valid Coupon Code.');
      }
    });
    if (code_html_err != '') {
      $('.discount-code-info').html(code_html_err);
    }
  } else {
    $('.applied-discount-code').html('');
    $('.applied-discount-code2').addClass('hide');
    if (flag) {
      $('.discount-code-error').html('Please Enter a Valid Coupon Code.');
    }
    $('.cart-items-subtotal').html(
      Shopify.formatMoney(data.items_subtotal_price, settings_new.moneyFormat)
    );
    $('.cart-items-discount').html(
      '-' + Shopify.formatMoney(data.total_discount, settings_new.moneyFormat)
    );
    let cart_total = data.total_price + window.shipping_fee;
    $('.cart_total_money').html(
      Shopify.formatMoney(cart_total, settings_new.moneyFormat)
    );
  }
  try {
    if ($('#cart-items-discount-save-price').length > 0) {
      var cart_items_discount_save_price = parseInt(
        $.trim($('#cart-items-discount-save-price').attr('value'))
      );
      if (cart_items_discount_save_price > 0) {
        data.total_discount =
          data.total_discount + cart_items_discount_save_price;
      }
    }
  } catch (e) {
    //console.log(e);
  }
  if ($('.cart_total_savings').length > 0) {
    let savingSelector = document.querySelector('.cart_total_savings');
    if (data.total_discount > 0) {
      $('.cart_total_savings').html(
        'Savings: ' +
          Shopify.formatMoney(data.total_discount, settings_new.moneyFormat)
      );
      savingSelector.classList.remove('hide');
    } else {
      savingSelector.classList.add('hide');
    }
  }
}
function clearDiscount(current_code) {
  $('.discount-code-error').html('');
  $('.discount-code-info').html('');
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    if ($(this).attr('data') == current_code) {
      $(this).remove();
    }
  });
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.length > 0) {
    var code_temp = code_arr.join(',');
  } else {
    var code_temp = 'none';
  }
  $('#discount-code-input').val('');
  $('.enj-minicart-ajax .total-info-order .cart-items-subtotal').html('');
  $('.enj-minicart-ajax .total-info-order .cart-items-discount').html('');
  $('.enj-minicart-ajax .prod').addClass('noDiscount');
  /*fetch("/discount/CLEAR").then(function(data){*/
  fetch('/checkout?discount=' + code_temp).then(function (data) {
    fetch('/cart.js', {})
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        showTotalData(data, 0);
      });
  });
}
function applyDiscount(code) {
  if ($.trim(code).length <= 0) {
    return;
  }
  code = code.toUpperCase();
  var code_arr = [];
  $('.applied-discount-code .applied-discount-code-wrapper').each(function () {
    code_arr.push($(this).attr('data'));
  });
  if (code_arr.indexOf(code) !== -1) {
    return;
  }
  code_arr.push(code);
  var code_temp = code_arr.join(',');
  $('.discount-code-error').html('');
  $('.discount-code-info').html('');
  $('.apply-discount-btn')
    .addClass('btn--loading')
    .html("Apply <div class='loader'></div>");
  $('.apply-discount-btn').css('pointerEvents', 'none');
  /*fetch(`/discount/${code_temp}`)*/
  fetch('/checkout?discount=' + code_temp)
    .then(function () {
      // After the discount code has been applied, force the cart to update so the discount is visible
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: {},
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          showTotalData(data, 1, String(code).toUpperCase());
          $('.apply-discount-btn').html('Apply');
          /*
      const discountCodes = data.discount_codes || []
      const discountFilter = discountCodes.filter(v=> v.code.toLocaleUpperCase() == codeName.toLocaleUpperCase());
      if (discountFilter.length == 0) {
        $(".apply-discount-btn").after("<div class='clear_discount_error'>"
          +"<strong>"+codeName+"</strong>"
          +"<span class='clear_discount_error_text'>couldn't be used with your existing discounts.</span>"
          +"<span class='clear_discount_error_icon'>"
          +'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" ">'
           +'<path stroke-linecap="round" d="M2.8 2.8 7 7m4.2 4.2L7 7m0 0 4.2-4.2M7 7l-4.2 4.2"></path>'
           +"</svg></span></div>"
          )
      }*/
        });
    })
    .then(function () {
      // 更新购物车显示（如果需要）
    })
    .catch(function (error) {
      console.error('Error--:', error);
    })
    .finally(function (params) {
      $('.apply-discount-btn').removeClass('btn--loading').html('Apply');
      $('.apply-discount-btn').css('pointer-events', 'all');
    });
}

function getShippingRate() {
  fetch('/cart/shipping_rates.json', {
    method: 'POST',
    body: JSON.stringify({
      shipping_address: {
        zip: '77523',
        country: 'United States',
        province: 'Texas',
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(function (parsedState) {
      if (
        parsedState &&
        parsedState.shipping_rates &&
        parsedState.shipping_rates.length > 0 &&
        parsedState.shipping_rates[0].price >= 0
      ) {
        window.shipping_fee = parsedState.shipping_rates[0].price * 100;
        var cart_shipping_fee_money = document.querySelectorAll(
          '.cart_shipping_fee_money'
        );
        for (var i = 0; i < cart_shipping_fee_money.length; i++) {
          cart_shipping_fee_money[i].innerHTML = Shopify.formatMoney(
            window.shipping_fee,
            settings_new.moneyFormat
          );
          cart_shipping_fee_money[i].style = 'opacity: 1';
        }
        let cart_total = 0;
        if ($('.cart_total_money').length > 0) {
          cart_total =
            parseInt($('.cart_total_money').attr('data-price')) +
            window.shipping_fee;
          $('.cart_total_money').html(
            Shopify.formatMoney(cart_total, settings_new.moneyFormat)
          );
        }
      }
    })
    .catch((e) => console.error(e));
}
